var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("backer-center-payments-tabs", {
    attrs: { "current-search-type": _vm.currentSearchType, "item-limit": 10 },
    on: { "tab-selected": _vm.onTabSelected },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("base-title", { attrs: { as: "h2", level: "h2" } }, [
              _vm._v(_vm._s(_vm.Resources.BackerCenter.SectionPaymentsHeader)),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "default",
        fn: function () {
          return [
            _c(
              "backer-center-section",
              {
                staticClass: "_mt-4",
                attrs: {
                  "link-more": _vm.linkMore,
                  "label-more": _vm.Resources.BackerCenter.ViewAllPaymentsLabel,
                  "is-loading": _vm.isProcessing,
                  "is-empty": !_vm.hasPayments,
                  "has-empty-action": false,
                  "empty-title":
                    _vm.Resources.BackerCenter.PaymentsEmptyStateHeader,
                  "empty-description":
                    _vm.Resources.BackerCenter.PaymentsEmptyStateParagraph,
                },
              },
              _vm._l(_vm.mappedPayments, function (payment) {
                return _c(
                  "backer-center-payments-preview",
                  _vm._b(
                    { key: payment.paymentID },
                    "backer-center-payments-preview",
                    payment,
                    false
                  )
                )
              }),
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }